import { parseAsStringLiteral, useQueryState } from 'nuqs'

const viewOptions = ['day', 'week'] as const
export type TimelineViewMode = (typeof viewOptions)[number]

export function useTimelineView() {
  const [view, setView] = useQueryState(
    'view',
    parseAsStringLiteral(viewOptions).withDefault('day'),
  )
  return { view, setView } as const
}
